import React from "react";
import { Button } from "@material-ui/core";
import { postUploadUserProfileImage } from '../../../api/upload';
//import config from '../../../config';
import {connect} from 'react-redux'
import {userUpdate} from '../../../actions/User';
//import { config} from "../../../config";
import IntlMessages from 'util/IntlMessages';

  class ProfileImageUpload2 extends React.Component {
 
   
    componentDidMount(){
      this.fileSelector = document.getElementById("customFile");
    }
 
    onChange = async(e)=>{
      
        const file = e.target.files[0]; 
        const formData = new FormData();
        formData.append('file',file);
        const fileObj = await postUploadUserProfileImage(formData,this.props.userId);
        if(!fileObj.status)
        {
          //console.log("HATA : ",fileObj.message)
          this.props.showWarningMessage(fileObj.message);
        }
        else{
          const {filePath} = fileObj;
          this.props.onChangeAvatar(''+filePath);

          ///eğer güncellediği kendi fotorafı ise
          if(this.props.user.id === this.props.authUser.id)
          {
            const user = this.props.user;
          user.profileImageUrl = filePath;
          this.props.userUpdate(user);
          this.props.showWarningMessage("Profil fotorafı başarıyla güncellendi.");

          }
        }
      
    }
    
    handleFileSelect = (e) => {
      e.preventDefault();
      this.fileSelector.click();
    }
    
    render(){
      const {variant,className} = this.props;
      return (
          <div>
                 <input type='file' id="customFile" onChange={this.onChange} style={{display:"none"}}></input>

            <Button className={className} variant={variant}  color="inherit" onClick={this.handleFileSelect}>
                <i className="zmdi zmdi-github zmdi-hc-lg"/>
                <span> <IntlMessages id="profile.profileImageUpdate"/></span>
                </Button>

                
       
          </div>
          
    
    )
    }
  }

  const mapStateToProps = ({auth}) => {

    const {authUser} = auth;
     return {authUser}
  
   };

  export default connect(mapStateToProps, {userUpdate})(ProfileImageUpload2);

//export default ProfileImageUpload2;